export const X_AXIS_HOURLY = [
  '0-3AM',
  '3-6AM',
  '6-9AM',
  '9-12PM',
  '12-15PM',
  '15-18PM',
  '18-21PM',
  '21-24PM',
]

export const X_AXIS_WEEKDAY = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export const nameToDatasetId = {
  YouTube: 'YouTube',
  'Kakao Talk': '카카오톡',
  Instagram: 'Instagram',
  Facebook: 'Facebook',
  Messenger: 'Messenger',
  NAVER: 'NAVER',
  Everytime: '에브리타임',
  BAND: 'BAND',
  NaverCafe: '네이버 카페',
  Slack: 'Slack',
  Classum: 'CLASSUM',
  Coupang: '쿠팡',
  배달요기요: '배달요기요',
  위메프: '위메프',
  Starbucks: '스타벅스',
  '11번가': '11번가',
  모바일교보문고: '모바일교보문고',
  'CJ ONE': 'CJ ONE',
  GMarket: 'G마켓',
  에이블리: '에이블리',
  이마트몰: '이마트몰',
  Twitter: '트위터',
  'Package installer': '패키지 설치 프로그램',
  'Polar Beat': 'Polar Beat',
  Paco: 'Paco',
  Settings: '설정',
  Message: '메시지',
  'Googe Play Service': 'Google Play 서비스',
  'Google Play Store': 'Google Play 스토어',
  Camera: '카메라',
  Logger: 'Logger',
}
